import React from "react";
const MarkdownMessage = ({ content, isUser }) => {
  const render = (text) => {
    const lines = text.split("\n");
    const elements = [];
    let i = 0;
    while (i < lines.length) {
      const line = lines[i];
      if (line.startsWith("# ")) {
        elements.push(
          <h1 key={i} style={{
            fontSize: "1.4rem",
            fontWeight: 800,
            color: isUser ? "var(--wa-bubble-text)" : "var(--wa-title)",
            margin: "16px 0 10px",
            lineHeight: 1.35,
            borderBottom: isUser ? "1px solid rgba(0,0,0,.12)" : "1px solid var(--border2)",
            paddingBottom: "7px"
          }}>
            {renderInline(line.slice(2))}
          </h1>
        );
        i++;
        continue;
      }
      if (line.startsWith("## ")) {
        elements.push(
          <h2 key={i} style={{
            fontSize: "1.18rem",
            fontWeight: 800,
            color: isUser ? "var(--wa-bubble-text)" : "var(--wa-title)",
            margin: "14px 0 7px",
            lineHeight: 1.35
          }}>
            {renderInline(line.slice(3))}
          </h2>
        );
        i++;
        continue;
      }
      if (line.startsWith("### ")) {
        elements.push(
          <h3 key={i} style={{
            fontSize: "1.06rem",
            fontWeight: 700,
            color: isUser ? "var(--wa-bubble-text)" : "var(--wa-title)",
            margin: "12px 0 6px",
            lineHeight: 1.35
          }}>
            {renderInline(line.slice(4))}
          </h3>
        );
        i++;
        continue;
      }
      if (line.match(/^[-•*]\s/)) {
        const listItems = [];
        while (i < lines.length && lines[i].match(/^[-•*]\s/)) {
          listItems.push(
            <li key={i} style={{ margin: "4px 0", lineHeight: 1.7 }}>
              {renderInline(lines[i].slice(2))}
            </li>
          );
          i++;
        }
        elements.push(
          <ul key={`ul-${i}`} style={{
            paddingRight: "1.4rem",
            paddingLeft: "1.4rem",
            margin: "6px 0",
            listStyle: "disc"
          }}>
            {listItems}
          </ul>
        );
        continue;
      }
      if (line.match(/^\d+\.\s/)) {
        const listItems = [];
        while (i < lines.length && lines[i].match(/^\d+\.\s/)) {
          const numEnd = lines[i].indexOf(". ");
          listItems.push(
            <li key={i} style={{ margin: "4px 0", lineHeight: 1.7 }}>
              {renderInline(lines[i].slice(numEnd + 2))}
            </li>
          );
          i++;
        }
        elements.push(
          <ol key={`ol-${i}`} style={{
            paddingRight: "1.4rem",
            paddingLeft: "1.4rem",
            margin: "6px 0",
            listStyle: "decimal"
          }}>
            {listItems}
          </ol>
        );
        continue;
      }
      if (line.match(/^---+$/)) {
        elements.push(<hr key={i} style={{ border: "none", borderTop: `1px solid ${isUser ? "rgba(255,255,255,.2)" : "var(--border2)"}`, margin: "10px 0" }} />);
        i++;
        continue;
      }
      if (line.trim() === "") {
        elements.push(<div key={i} style={{ height: "6px" }} />);
        i++;
        continue;
      }
      elements.push(
        <p key={i} style={{ margin: "3px 0", lineHeight: 1.75 }}>
          {renderInline(line)}
        </p>
      );
      i++;
    }
    return elements;
  };
  const renderInline = (text) => {
    const parts = [];
    let remaining = text;
    let keyIdx = 0;
    while (remaining.length > 0) {
      const boldMatch = remaining.match(/\*\*(.+?)\*\*/);
      const italicMatch = remaining.match(/\*(.+?)\*/);
      const codeMatch = remaining.match(/`(.+?)`/);
      const linkMatch = remaining.match(/\[([^\]]+?)\]\([^)]+?\)/);
      const urlMatch = remaining.match(/(https?:\/\/[^\s]+)/);
      const matches = [
        boldMatch && { idx: boldMatch.index, len: boldMatch[0].length, type: "bold", inner: boldMatch[1] },
        italicMatch && { idx: italicMatch.index, len: italicMatch[0].length, type: "italic", inner: italicMatch[1] },
        codeMatch && { idx: codeMatch.index, len: codeMatch[0].length, type: "code", inner: codeMatch[1] },
        linkMatch && { idx: linkMatch.index, len: linkMatch[0].length, type: "link", text: linkMatch[1], href: linkMatch[2] },
        urlMatch && { idx: urlMatch.index, len: urlMatch[0].length, type: "url", text: urlMatch[0], href: urlMatch[0] }
      ].filter(Boolean).sort((a, b) => a.idx - b.idx);
      if (!matches.length) {
        parts.push(<span key={keyIdx++}>{remaining}</span>);
        break;
      }
      const m = matches[0];
      if (m.idx > 0) parts.push(<span key={keyIdx++}>{remaining.slice(0, m.idx)}</span>);
      if (m.type === "bold") {
        parts.push(
          <strong key={keyIdx++} style={{ fontWeight: 700, color: isUser ? "var(--wa-bubble-text)" : "var(--wa-title)" }}>
            {m.inner}
          </strong>
        );
      }
      if (m.type === "italic") {
        parts.push(<em key={keyIdx++} style={{ fontStyle: "italic" }}>{m.inner}</em>);
      }
      if (m.type === "code") {
        parts.push(
          <code key={keyIdx++} style={{ background: isUser ? "rgba(255,255,255,.15)" : "var(--bg-base)", padding: "1px 6px", borderRadius: 5, fontSize: "0.88em", fontFamily: "monospace" }}>
            {m.inner}
          </code>
        );
      }
      if (m.type === "link" || m.type === "url") {
        const href = m.href.startsWith("http") ? m.href : `https://${m.href}`;
        parts.push(
          <a
            key={keyIdx++}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: isUser ? "#9bd9ff" : "var(--accent)", textDecoration: "underline" }}
          >
            {m.type === "link" ? m.text : m.text}
          </a>
        );
      }
      remaining = remaining.slice(m.idx + m.len);
    }
    return parts;
  };
  return <div style={{ fontSize: "16px", lineHeight: 1.78, fontFamily: "var(--chat-font)", fontWeight: 420 }}>
      {render(content)}
    </div>;
};
var stdin_default = MarkdownMessage;
export {
  stdin_default as default
};
